import { goto } from '@wheelbox/lithejs-router';
import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

import Icon from '../../../../layout/icon';

import { createId } from '../../../../../utils';

import { SearchResult } from '../types';
import withTranslations from '@wheelbox/lithejs-i18n';

type SearchResultsProps = {
  string: string;
  results: SearchResult[];
};

const SearchResults: LitheFC<SearchResultsProps> = ({
  id = createId(),
  testId = 'search-results',
  string,
  results,
}): LitheElement<'ul'> | LitheElement<'p'> | undefined => {
  const t = withTranslations('Search');

  if (results.length > 0) {
    return [
      'ul',
      {
        id,
        'data-testid': testId,
        class: 'list-none ps-0 max-h-64 overflow-y-auto',
      },
      [
        'p',
        { class: 'text-sm text-gray-500 mb-2' },
        `Results for `,
        ['span', { class: 'text-primary font-semibold' }, string],
      ],
      ...results.map<LitheElement<'li'>>((result) => [
        'li',
        {
          class:
            'py-2 px-4 flex items-center gap-2 cursor-pointer hover:bg-background hover:text-primary rounded',
          onclick: () => goto(`/tutorial/${result.filename}`),
        },
        Icon({ icon: 'docs', classes: 'w-5 h-5 fill-text' }),
        result.title,
      ]),
    ];
  }

  if (string) {
    return [
      'p',
      { class: 'text-sm text-gray-500 mb-2' },
      t('no_results'),
      ['span', { class: 'text-primary font-semibold' }, string],
    ];
  }

  return undefined;
};

export default SearchResults;
